import _ from 'lodash'

export default function chatSessionsListTransformer(conversations) {
  return _.keyBy(conversations, 'uuid')
}
